export class PathologyDTO {
	constructor(
		public id?: number,
		public value: string = '',
		public imagingCenterId?: number,
		public category?: string
	) {}
}
